import localesEs from '@/views/Auth/i18n/localeEs';

export default {
  es: {
    ...localesEs.es,
    SEO_TITLE: 'Inicia sesión',
    SEO_DESCRIPTION: 'Inicia sesión y aprende nuevas habilidades hoy.',
    FORM_TITLE: 'Bienvenido',
    FORM_DESCRIPTION: 'Comienza tu aprendizaje con Crehana para Empresas.',
    INPUT_EMAIL_LABEL: 'Correo',
    INPUT_EMAIL_HINT: 'Ingresa tu correo',
    INPUT_PASSWORD_LABEL: 'Contraseña',
    INPUT_PASSWORD_HINT: 'Ingresa contraseña',
    FORGOT_PASSWORD: '¿Olvidaste la contraseña?',
    BUTTON_SUBMIT_LABEL: 'Inicia sesión',
    FIRST_TIME_IN_CREHANA: '¿Es la primera vez que usas Crehana?',
    REGISTER: 'Regístrate',
    LOGIN_WITH_YOUR_ORGANIZATION: 'Inicia con tu organización',
    LOGIN_WITH_YOUR_ORGANIZATION_DESKTOP: 'Inicia sesión con tu organización',
  },
};
